import LabelField from '@app/components/atoms/LabelField/LabelField'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { useTranslation } from 'react-i18next'

const LineOfCreditSection = ({ register, errors, trigger }) => {
  const { t } = useTranslation()
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <LabelField required recommend={t('CAMPAIGN.LINE_OF_CREDIT_RECOMMEND')} title={t('CAMPAIGN.LINE_OF_CREDIT')}>
          <TextField
            fullWidth
            name="line_of_credit"
            size="small"
            type="number"
            variant="outlined"
            {...register('line_of_credit')}
            error={errors.line_of_credit ? true : false}
            helperText={errors.line_of_credit?.message}
            onFocus={() => trigger('line_of_credit')}
          />
        </LabelField>
      </Grid>
    </Grid>
  )
}
export default LineOfCreditSection
